import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { MiniTestimonials } from './components/MiniTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { TomosGrid } from './components/TomosGrid';
import { BonosGrid } from './components/BonosGrid';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingCards } from './components/PricingCards';
import { PatologiasPro } from './components/PatologiasPro';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full min-h-full bg-white text-navy-900 font-sans" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <AnnouncementBar data-id="element-2" />
      <Hero data-id="element-3" />
      <MiniTestimonials data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductReveal data-id="element-6" />
      <TomosGrid data-id="element-7" />
      <BonosGrid data-id="element-8" />
      <UrgencyBlock data-id="element-9" />
      <PricingCards data-id="element-10" />
      <PatologiasPro data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <ComparisonTable data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}